import { useQuery } from '@tanstack/react-query';
import { officeRateLimitsKeys } from '../queryKeys';
import { OfficeRateLimitsService } from '../services';

/**
 * An identity's rate limits in every organization it belongs to. The caller
 * renders the failure inline, so the global toaster stays off and a failure
 * surfaces on the first attempt.
 *
 * @param {string} [identityId]
 */
export const useGetMemberRateLimits = (identityId) =>
  useQuery({
    queryKey: officeRateLimitsKeys.member(identityId),
    queryFn: () => OfficeRateLimitsService.getMemberRateLimits(identityId),
    meta: { skipGlobalErrorToaster: true },
    enabled: Boolean(identityId),
    retry: false,
    refetchOnWindowFocus: false,
  });
